import type { PointerEvent } from 'react';

const EDGE_STYLES: Record<string, string> = {
    top: 'inset-x-0 top-0 h-1.5 cursor-ns-resize',
    bottom: 'inset-x-0 bottom-0 h-1.5 cursor-ns-resize',
    left: 'inset-y-0 left-0 w-1.5 cursor-ew-resize',
    right: 'inset-y-0 right-0 w-1.5 cursor-ew-resize',
};

interface ResizeEdgeProps {
    direction: string;
    onStart: (e: PointerEvent) => void;
}

export function ResizeEdge({ direction, onStart }: ResizeEdgeProps) {
    return (
        <div
            className={`absolute z-[4] ${EDGE_STYLES[direction]}`}
            onPointerDown={onStart}
        />
    );
}
